/* ======================================================================
   DRAFT UX — R12 (scrolled header state) and R13 (overlay sequencing)
   ----------------------------------------------------------------------
   Paired with assets/draft-ux.css. Deliberately dependency-free and
   defensive: if anything here fails, the page is left in its normal
   state rather than a half-gated one.
   ====================================================================== */
(function () {
  'use strict';

  var root = document.documentElement;

  /* --------------------------------------------------------------------
     R12 — mark the page as scrolled so the header can condense.
     A small hysteresis gap (72 down / 48 up) stops the header flickering
     when the user hovers around the threshold.
     ------------------------------------------------------------------ */
  var SCROLL_ON = 72;
  var SCROLL_OFF = 48;
  var scrolled = false;
  var lastRun = 0;
  var THROTTLE_MS = 80;

  function readScroll() {
    var y = window.pageYOffset || root.scrollTop || 0;
    if (!scrolled && y > SCROLL_ON) {
      scrolled = true;
      root.setAttribute('data-scrolled', '');
    } else if (scrolled && y < SCROLL_OFF) {
      scrolled = false;
      root.removeAttribute('data-scrolled');
    }
  }

  /* A time-based throttle rather than requestAnimationFrame: rAF is paused
     whenever the page is not compositing (background tabs, and headless
     preview panes), which would leave the header stuck in its tall state.
     The listener is passive, so this stays off the scrolling critical path. */
  function onScroll() {
    var now = Date.now();
    if (now - lastRun < THROTTLE_MS) return;
    lastRun = now;
    readScroll();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  readScroll();

  /* --------------------------------------------------------------------
     R13 — sequence the overlays.

     The hero must be the first brand impression, so the Klaviyo welcome
     form is held until BOTH are true:
       1. the Shopify consent banner is no longer on screen, and
       2. the visitor has spent ~30s OR scrolled ~30% of the page.

     A hard 90s ceiling releases the gate regardless, so a visitor who
     never touches the banner is not permanently denied the form.
     ------------------------------------------------------------------ */
  var HOLD_CLASS = 'klv-hold';
  var DWELL_MS = 30000;
  var SCROLL_FRACTION = 0.3;
  var CEILING_MS = 90000;

  root.classList.add(HOLD_CLASS);

  var released = false;
  var startedAt = Date.now();

  function consentVisible() {
    var banner = document.getElementById('shopify-pc__banner');
    if (!banner) return false;
    var style = window.getComputedStyle(banner);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return banner.getBoundingClientRect().height > 0;
  }

  function scrolledEnough() {
    var doc = document.documentElement;
    var scrollable = doc.scrollHeight - window.innerHeight;
    if (scrollable <= 0) return false;
    return (window.pageYOffset || doc.scrollTop || 0) / scrollable >= SCROLL_FRACTION;
  }

  function release() {
    if (released) return;
    released = true;
    root.classList.remove(HOLD_CLASS);
    window.removeEventListener('scroll', maybeRelease);
    if (timer) clearInterval(timer);
  }

  function maybeRelease() {
    if (released) return;
    var elapsed = Date.now() - startedAt;
    if (elapsed >= CEILING_MS) return release();
    if (consentVisible()) return; // consent always goes first
    if (elapsed >= DWELL_MS || scrolledEnough()) release();
  }

  var timer = setInterval(maybeRelease, 1000);
  window.addEventListener('scroll', maybeRelease, { passive: true });

  /* Safety net: never leave the form permanently hidden if something above
     throws or the page sits idle in a background tab. */
  window.setTimeout(release, CEILING_MS + 5000);

  /* --------------------------------------------------------------------
     R7 — remove Klaviyo's Google Fonts import.

     Klaviyo injects <style id="kl-custom-fonts"> containing an @import for
     Bebas Neue, Montserrat and Oswald. Those faces are unused here (the
     forms are forced onto Karla in brand-typography.css), but the import
     is still an external Google Fonts request.

     This strips the node as soon as it appears. Note the honest limit: if
     Klaviyo injects it before this observer starts, the request may fire
     once before removal. The definitive fix is to clear the custom fonts
     in the Klaviyo form designer, which is a dashboard setting.
     ------------------------------------------------------------------ */
  function stripKlaviyoFonts() {
    var node = document.getElementById('kl-custom-fonts');
    if (node && node.parentNode) {
      node.parentNode.removeChild(node);
      return true;
    }
    return false;
  }

  stripKlaviyoFonts();

  if (window.MutationObserver) {
    var observer = new MutationObserver(function () {
      stripKlaviyoFonts();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    // stop watching once the page has settled, so we are not observing forever
    window.setTimeout(function () {
      observer.disconnect();
      stripKlaviyoFonts();
    }, 20000);
  }
})();
